import styled from "styled-components";

import { theme } from "../../layout";

export const Container = styled.header`
  display: flex;
  height: 88px;
  background-color: ${theme.header.background};
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
`;
